export const LoadingTitle = () => {
  return (
    <div className='loading w-full h-6 rounded-md'></div>
  )
}
